(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["siren-measurement"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.documentElement;
  if (root.hasAttribute('data-siren-measurement-ready')) return;
  root.setAttribute('data-siren-measurement-ready', 'true');
  const placements = new Set(['siren_home_hero', 'siren_hero', 'layers_hero', 'trending_now', 'siren_look', 'matching_piece', 'size_guide']);
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || (event.button !== undefined && event.button !== 0)) return;
    const link = event.target instanceof Element ? event.target.closest('[data-siren-placement]') : null;
    if (!link || link.disabled || link.getAttribute('aria-disabled') === 'true') return;
    const placement = link.dataset.sirenPlacement;
    if (!placements.has(placement)) return;
    const shopify = window.Shopify;
    try {
      if (shopify?.designMode || !shopify?.customerPrivacy?.analyticsProcessingAllowed?.() || typeof shopify?.analytics?.publish !== 'function') return;
    } catch { return; }
    const href = link.dataset.sirenDestination || link.getAttribute('href');
    if (!href) return;
    let destination;
    try {
      destination = new URL(href, location.origin);
    } catch { return; }
    if (destination.origin !== location.origin) return;
    const payload = {
      placement,
      destination: destination.pathname,
      device_category: window.matchMedia('(max-width: 749px)').matches ? 'mobile' : 'desktop'
    };
    const view = destination.searchParams.get('view');
    if (view && /^[a-z-]{1,40}$/.test(view)) payload.destination_view = view;
    if (link.dataset.sirenCategory) payload.category = link.dataset.sirenCategory.slice(0, 80);
    if (/^[1-9]\d?$/.test(link.dataset.sirenPosition || '')) payload.position = Number(link.dataset.sirenPosition);
    if (/^\d+$/.test(link.dataset.sirenProductId || '')) payload.product_id = link.dataset.sirenProductId;
    if (/^\d+$/.test(link.dataset.sirenSourceProductId || '')) payload.source_product_id = link.dataset.sirenSourceProductId;
    const look = link.closest('[data-siren-look-id]');
    if (look) payload.look_id = look.dataset.sirenLookId.slice(0, 80);
    try {
      const result = shopify.analytics.publish('mila_siren:interaction', payload);
      if (result && typeof result.catch === 'function') result.catch(() => {});
    } catch {}
  });
})();
  } catch(e) { console.error(e); }
})();

})();
